import { api } from "../lib/api";

// outfitCurationEngine.getSixOccasionOutfits(occasion, styleDirection, hairstyle)
export async function getSixOccasionOutfits(occasion, styleDirection, hairstyle, budget) {
  const { data } = await api.post("/ai/outfit-curation", { occasion, styleDirection, hairstyle, budget });
  return data.options; // [{ title, topwear, bottomwear, footwear, accessory, priceRange, stores[] }]
}

// Relevant accessories + grooming products for the selected outfit/occasion
export async function getAccessoriesAndProducts(occasion, styleDirection, outfit, beardStatus) {
  const { data } = await api.post("/ai/accessories-products", { occasion, styleDirection, outfit, beardStatus });
  return data; // { accessories[], products[] }
}
